<template>
  <div class="app-card-partner">
    <div class="app-card-partner__logo" v-if="data.logoLink">
      <img :src="data.logoLink" alt="logo">
    </div>
    <div class="app-card-partner__tag" v-if="data.tag">
      {{ data.tag }}
    </div>
    <div class="app-card-partner__description" v-if="data.description">
      {{ data.description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCardEvent',
  props: ['data'],
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
  @import "app-card-partner";
</style>
